import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FileDeleteService } from '../file-delete-service';
import { FileDeleteApi, type FileContentType } from '../../apis/file-delete-api';

@injectable()
export class FileDeleteServiceImpl implements FileDeleteService {
    constructor(
        @inject(FileDeleteApi)
        private _fileDeleteApi: FileDeleteApi,
    ) {}

    async deleteFile(taskId: string, contentType: FileContentType): Promise<boolean> {
        return await this._fileDeleteApi.deleteFile({ taskId, contentType });
    }
}
